export enum UserThemeEnum {
    LIGHT = 'LIGHT',
    DARK = 'DARK',
    SUNRISE = 'SUNRISE',
    SERENE = 'SERENE',
    BLISS = 'BLISS',
    LUSH = 'LUSH',
}
